import {
  profile,
  skills,
  education,
  resumeEducation,
  personalSkills,
  experience,
  hobbies,
  technicalSkills,
  pdfSkills,
  portfolioItems,
  liveProducts,
} from '@/data/profile'

export function getDefaultSiteData() {
  return {
    profile: JSON.parse(JSON.stringify(profile)),
    skills: JSON.parse(JSON.stringify(skills)),
    education: JSON.parse(JSON.stringify(education)),
    resumeEducation: JSON.parse(JSON.stringify(resumeEducation)),
    personalSkills: [...personalSkills],
    experience: JSON.parse(JSON.stringify(experience)),
    hobbies: [...hobbies],
    technicalSkills: JSON.parse(JSON.stringify(technicalSkills)),
    pdfSkills: JSON.parse(JSON.stringify(pdfSkills)),
    portfolioItems: JSON.parse(JSON.stringify(portfolioItems)),
    liveProducts: JSON.parse(JSON.stringify(liveProducts)),
    homeStats: [
      { value: '3+', label: 'Years Experience' },
      { value: '10+', label: 'Technologies' },
      { value: 'BS IT', label: 'MinSU Graduate' },
      { value: 'Open', label: 'For Freelance' },
    ],
    contactMapUrl:
      'https://maps.google.com/maps?width=600&height=400&hl=en&q=Bagong+Buhay+Victoria+Oriental+Mindoro&t=&z=14&ie=UTF8&iwloc=B&output=embed',
  }
}
